import styled from 'styled-components';
import { IToken } from 'store/ducks/globalTypes';

export const TableWrapper = styled('div')<IToken & { scheme?: string }>`
  .ant-table-wrapper .ant-table {
    .ant-table-thead {
      display: none;
    }

    .ant-table-row.ant-table-row-level-0 {
      > .ant-table-cell {
        padding: 10px 16px 30px !important;

        > div {
          margin: unset;
          padding: ${(props) => `${props.token.padding}px`};
        }

        .ant-select {
          // display: block;
        }
      }
    }

    .ant-table-tbody {
      > tr {
        &:hover > td {
          background: ${(props) => props.token.colorBgLayout};
        }

        > td {
          border-bottom: ${(props) => {
            // Only apply borders for Gaps Definition page (identified by specific class or context)
            const isGapsDefinition =
              document.querySelector('.gaps-definition-page') ||
              document.querySelector('[class*="GapsDescriptionTable"]') ||
              window.location.pathname.includes('gaps');

            if (isGapsDefinition) {
              const { themesList } = require('constants/themesList');
              const currentTheme = themesList[props.scheme || 'deepBlueTheme'];
              const borderColor = currentTheme?.tableBorder || '#d9d9d9';
              return `1px solid ${borderColor} !important`;
            } else {
              return 'none !important';
            }
          }};
        }
      }
    }
  }
  .ant-table .ant-table-container .ant-table-content {
    overflow: visible;
  }
  .ant-table-wrapper
    .ant-spin-nested-loading
    .ant-spin-container
    .ant-pagination {
    display: none;
  }
`;
